import Resources from "build/resources";
import ErrorReport from "app/utils/error-report";
import Log from "app/utils/log";
import deadline from "app/utils/deadline";

const log = new Log("TrigrService");
const TRIGR_ENDPOINT = `${ Resources.TRIGR_API }/targets`;
const TRIGR_TIMEOUT = 500; //ms

class TrigrService {
    getTrigrResults() {
        return deadline(TRIGR_TIMEOUT, fetch(TRIGR_ENDPOINT, { mode: "cors" }))
            .then((res) => {
                const contentType = res.headers.get("content-type");
                if (res.ok && contentType && contentType.indexOf("application/json") !== -1) {
                    return res.json();
                }
                throw new Error("Trigr Service returned an invalid response");
            })
            .catch((reason) => {
                ErrorReport.recordLoadError(log, TRIGR_ENDPOINT, "Error fetching trigr data ", reason);
            });
    }
}

export default TrigrService;
